import io from "socket.io-client";

// console.log("socket connect init");
// var socket = io.connect("https://api.outpostchess.com");
// //window.socket = socket;
// console.log("socket connect req");
// socket.on("connect", async function () {
//     console.log("socket connected, sending token:", localStorage.getItem("token"));
//     socket.emit("client_token", localStorage.getItem("token"));
// });

const socketUtil = {
    socket: null,
    connect: async () => {
        try {
            const token = await localStorage.getItem("token"); // 'token' is the key where you stored the token
            if (token) {
                socketUtil.socket = await io.connect("https://api.outpostchess.com", {
                    transports: ["websocket", "polling", "webtransport"], // use WebSocket first, if available
                });

                socketUtil.socket.on("connect", async function () {
                    //console.log("socket connected, sending token:", localStorage.getItem("token"));

                    socketUtil.socket.emit("client_token", localStorage.getItem("token"));
                });
            } else {
                console.log("No token found in SecureStore. Socket not initialized.");
            }
        } catch (error) {
            console.error("Error retrieving token from SecureStore:", error);
        }
    },
    subscribe: async (topic, callback) => {
        // console.log('22',socketUtil.socket)
        if (socketUtil.socket == null || socketUtil.socket.connected == false) {
            await socketUtil.connect();
            //    console.log('33',socketUtil.socket)
        }
        socketUtil.socket.on(topic, callback);
    },
    /*  disconnect: async() => {
        socketUtil.socket = await io.disconnect("https://api.outpostchess.com");
        console.log('44',socketUtil.socket)
        socketUtil.socket.on("disconnect", async function () {
            console.log("socket disconnected");

        
        });

    } */
};

//socket.on('tb_notification', function(payload){
// console.log(payload)
//})

export default socketUtil;
